export default __webpack_public_path__ + "static/media/Hali2.94d84cad.png";